export default "__VITE_ASSET__7Z0Ilb1W__"